import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { TabPanel, TabView } from "primereact/tabview";
import Loader from "../../../components/Loadeer/Loader";
import AppBreadcrumb from "../../../components/CustomeBreadcrumb/AppBreadcrumb";
import { getSpecificDetails } from "../../../service/ProductService";
import { GET_OPERATORBYID } from "../../../config/ApiConstant";
import { Toast } from "primereact/toast";
import OperatorBookingList from "./OperatorBookingList";
import { Tag } from "primereact/tag";
import MoneyReceivedList from "./MoneyReceivedList";

const OperatorDetail = () => {
  document.title = "Operator Details | Agriown";

  // Set Toast
  const toast = useRef<Toast>(null);

  // Get User ID From URL
  const { id }: any = useParams();
  // Decode User ID
  const operator_id = atob(id);

  // state for storing user data
  const [userData, setUserData] = useState<any>({});

  // state for active tab index
  const [activeIndex, setActiveIndex] = useState<number>(0);

  // loading state
  const [pageLoader, setPageLoader] = useState<boolean>(false);

  // useEffect to get user profile data on page load
  useEffect(() => {
    getProfileData();
  }, [operator_id]);

  // get user profile data
  const getProfileData = async () => {
    try {
      setPageLoader(true);
      const response = await getSpecificDetails(GET_OPERATORBYID, operator_id);

      if (response) {
        setUserData(response);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data?.message,
      });
    } finally {
      setPageLoader(false);
    }
  };

  // spliting type of equiment string by comma separator
  const values = !window.cn(userData.type_of_equipment)
    ? userData.type_of_equipment.split(",").map((item: any) => item.trim())
    : [];

  return (
    <>
      {/* Breadcrumb */}
      <AppBreadcrumb
        currentMenu={"Operator"}
        pageName={"Operator Details"}
        pageTitle={"Operator Details"}
        goToPage={true}
      />
      <Toast ref={toast} />
      {!window.cn(userData) && (
        <div className="grid mt-3 profile-page">
          <div className="pb-0 col-12">
            <div className="card profile-card">
              <div className="card-profile-detail">
                <div>
                  {!window.cn(userData?.profile_img) ? (
                    <div className="img-fluid">
                      <img
                        src={userData?.profile_img}
                        className="img-fluid"
                        width={100}
                        height={100}
                      />
                    </div>
                  ) : (
                    <div className="img-fluid">
                      <img
                        src={
                          "https://dummyimage.com/100x100/e0e0e0/363636.jpg&text=No+image"
                        }
                        className="img-fluid"
                        width={100}
                        height={100}
                      />
                    </div>
                  )}
                </div>
                <div className="pt-0 md:ml-4 p-other-info">
                  {!window.cn(userData?.name) && (
                    <div>
                      <h6 className="mb-0 full-n-p">{userData?.name}</h6>
                    </div>
                  )}
                  <div className="flex personal-info">
                    {!window.cn(userData?.email) && (
                      <div className="flex mr-5 align-items-center">
                        <i className="mr-2 pi pi-envelope"></i>
                        <h6 className="mt-0 mb-0 desg">{userData?.email}</h6>
                      </div>
                    )}
                    {!window.cn(userData?.mobile) && (
                      <div className="flex mr-5 align-items-center">
                        <i className="mr-2 pi pi-phone"></i>
                        <h6 className="mt-0 mb-0 desg">{userData?.mobile}</h6>
                      </div>
                    )}
                  </div>
                  {!window.cn(userData?.type_of_equipment) && (
                    <div className="flex mr-5 align-items-center">
                      <span className="font-bold mr-2">
                        Types of Equipements -
                      </span>
                      {/* <i className="mr-2 pi pi-wrench"></i> */}
                      <h6 className="mt-0 mb-0 desg">
                        <div className="flex flex-wrap gap-1">
                          {values.map((val: any, index: any) => (
                            <Tag key={index} value={val} severity="warning" />
                          ))}
                        </div>
                      </h6>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Tab View */}
      <TabView
        activeIndex={activeIndex}
        onTabChange={(e) => setActiveIndex(e.index)}
        className="profile-tab"
      >
        <TabPanel header="Booking">
          <OperatorBookingList />
        </TabPanel>
        <TabPanel header="Money Received List">
          <MoneyReceivedList />
        </TabPanel>
      </TabView>

      {pageLoader === true && <Loader />}
    </>
  );
};

export default OperatorDetail;
